// extracted by mini-css-extract-plugin
export default {"layout":"PageLoader_layout__vsy1I","loader":"PageLoader_loader__TCj2u","rotation":"PageLoader_rotation__wjb+M"};